import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyFormat]',
})
export class CurrencyFormatDirective implements OnInit {
  constructor(
    private readonly el: ElementRef<HTMLInputElement>,
    private readonly control: NgControl
  ) {}

  ngOnInit(): void {
    const val = this.control.value;
    if (val != null && val !== '') {
      this.el.nativeElement.value = this.format(val);
    }
  }

  @HostListener('focus')
  onFocus(): void {
    const raw = this.control.value;
    this.el.nativeElement.value = raw != null && raw !== '' ? String(raw) : '';
  }

  @HostListener('blur')
  onBlur(): void {
    const raw = this.el.nativeElement.value.replace(/,/g, '');
    const num = parseFloat(raw);
    if (!isNaN(num)) {
      this.control.control?.setValue(num, { emitEvent: true });
      this.el.nativeElement.value = this.format(num);
    } else {
      this.control.control?.setValue(null, { emitEvent: true });
      this.el.nativeElement.value = '';
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // Strip everything except digits and one decimal point while typing
    const cleaned = value.replace(/[^0-9.]/g, '');
    this.el.nativeElement.value = cleaned;
    const num = parseFloat(cleaned);
    this.control.control?.setValue(isNaN(num) ? null : num, { emitEvent: true });
  }

  private format(value: number | string): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    return num.toLocaleString('en-US');
  }
}
